export default {
  isAdmin: false,
}
